import { LightFloodUpIcon } from './LightFloodUpIcon';

/**
 * author: Tim Grelka
 * id 9CE460EF-B246-4833-AF6D-B6ACB2A1E9A8
 * name light-flood-up
 * version: 6.5.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/light-flood-up.svg
 * tags
 * - Home Automation 
 */
export const FloodlightUpIcon = LightFloodUpIcon;
export default FloodlightUpIcon